import React, { useState } from 'react';

export interface CustomerInfo {
  companyName: string;
  email: string;
  phone?: string;
  contactPerson?: string;
}

interface NotesPanelProps {
  notes: string;
  onNotesChange: (notes: string) => void;
  customerInfo: CustomerInfo;
  onCustomerInfoChange: (info: CustomerInfo) => void;
  onToggleExpanded: (expanded: boolean) => void;
  onToggleDiscount?: () => void;
  showDiscount?: boolean;
}

export const NotesPanel: React.FC<NotesPanelProps> = ({ 
  notes, 
  onNotesChange, 
  customerInfo,
  onCustomerInfoChange,
  onToggleExpanded, 
  onToggleDiscount, 
  showDiscount 
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleToggleExpanded = (expanded: boolean) => {
    setIsExpanded(expanded);
    onToggleExpanded(expanded);
  };

  const handleCustomerInfoChange = (field: keyof CustomerInfo, value: string) => {
    onCustomerInfoChange({
      ...customerInfo,
      [field]: value
    });
  };

  return (
    <>
      <div className="notes-tab-container">
        <button 
          className="tab-handle"
          onClick={() => handleToggleExpanded(!isExpanded)}
          title={isExpanded ? "Notities inklappen" : "Notities uitklappen"}
        >
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className="tab-arrow"
          >
            <path d="M9 18L15 12L9 6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        
        {isExpanded && (
          <div className="notes-panel">
            <div className="customer-info-section">
              <h3>Klantgegevens</h3>
              <div className="customer-form">
                <div className="form-group">
                  <label htmlFor="companyName">Bedrijfsnaam</label>
                  <input
                    id="companyName"
                    type="text"
                    value={customerInfo.companyName}
                    onChange={(e) => handleCustomerInfoChange('companyName', e.target.value)}
                    placeholder="Voer bedrijfsnaam in"
                    className="customer-input"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="contactPerson">Contactpersoon (optioneel)</label>
                  <input
                    id="contactPerson"
                    type="text"
                    value={customerInfo.contactPerson || ''}
                    onChange={(e) => handleCustomerInfoChange('contactPerson', e.target.value)}
                    placeholder="Voer naam contactpersoon in"
                    className="customer-input"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email">E-mail</label>
                  <input
                    id="email"
                    type="email"
                    value={customerInfo.email}
                    onChange={(e) => handleCustomerInfoChange('email', e.target.value)}
                    placeholder="Voer e-mailadres in"
                    className="customer-input"
                  />
                </div>
              </div>
            </div>

            <div className="notes-content">
              <h3>Notities</h3>
              <textarea
                value={notes}
                onChange={(e) => onNotesChange(e.target.value)}
                placeholder="Voer hier je notities in..."
                className="notes-textarea"
              />
            </div>

            <div className="notes-footer">
              <div className="character-count">
                {notes.length} karakters
              </div>
              <div className="notes-buttons">
                <button 
                  className="save-button"
                  onClick={() => handleToggleExpanded(false)}
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3H16L21 8V19C21 20.1046 20.1046 21 19 21Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M17 21V13H7V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M7 3V8H15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                  Opslaan
                </button>
                {onToggleDiscount && (
                  <button 
                    className="secret-button"
                    onClick={onToggleDiscount}
                  >
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill={showDiscount ? "currentColor" : "none"}/>
                    </svg>
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
